import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    isCrossingPageRoot,
    navigateToPage,
    type AppNavigateFunction,
    type AppNavigateOptions,
} from '@sorrem-client/ui/shared/app-navigation';

/**
 * Navigates like the router's `navigate` inside the current page, and with
 * a full page load when the target is another page.
 */
export function useAppNavigate(): AppNavigateFunction {
    const navigate = useNavigate();

    return useCallback((to: string, options: AppNavigateOptions = {}): void => {
        if (isCrossingPageRoot(window.location.pathname, to)) {
            navigateToPage(to, options);
            return;
        }

        navigate(to, options);
    }, [navigate]);
}
